<div class="text-center main">
  <!-- <i class="fas fa-grin fa-10x text-center"></i> -->
  <div class="icon-wrap" aria-hidden="true">
    <div class="icon">
      <div class="smile"></div>
    </div>
  </div>

  <h1>¡Gracias por completar esta encuesta!</h1>

  <p class="textoP my-3">
    Estaremos analizando los resultados para mejorar su experiencia al momento
    de contratar nuestros servicios y productos.
  </p>
  <app-custom-button
    label="Ir al sitio institucional"
    button_style="outline"
    redirectUrl="https://www.certant.com/"
  >
  </app-custom-button>
</div>
